var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_vm._v("\n    Something went wrong loading your data, please try again. \n    If the problem persists, please contact the support team.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }